<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text
            v-if="text_markdown"
        >
            <m-showdown :value="text" />
        </v-card-text>

        <v-card-text
            v-else
            v-html="text"
        >
        </v-card-text>

        <transition name="fade" mode="out-in">
            <v-card-text v-if="new_version_available" key="version-alert">
                <v-alert
                    type="primary"
                    border="left"
                    colored-border
                    class="shaded my-0"
                >
                    <div class="subtitle-2 ml-2 mb-2">
                        App Update Available
                    </div>
                    <div class="body-2 ml-2">
                        A new version of the app has been deployed and could resolve this issue.
                        <a href="#" @click.prevent="refreshPage" class="text-decoration-none font-weight-medium">
                            Click here to refresh the page
                        </a> 
                        and try again.
                    </div>
                </v-alert>
            </v-card-text>
        </transition>
        
        <v-card-actions>
        <v-btn
            v-if="technical_details != null"
            v-on:click="onClickTechnicalDetails"
            text
        >
            Technical Details
        </v-btn>    

        <v-spacer></v-spacer>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>

    </v-card>

</v-dialog>
</template>

<script>
const Validate = require('@/js/validate.js');
var Preconditions = require('@/js/Preconditions.js'); 
import VersionService from '@/js/HashVersion.js';

export default {
    data() {
        return {
            dialog: false,
            
            title: '',
            text: '',
            after_alert: null,
            technical_details: null,
            text_markdown: false, 

            new_version_available: false,
        }
    },

    created () {
        this.$event_bus.$on('alert', this.onAlert);
    },

    beforeDestroy () {
        this.$event_bus.$off('alert', this.onAlert);
    },

    methods: {
        async onAlert(params) {
            this.showDialog(params);
            if (params.check_front_end_version) {
                this.new_version_available = await VersionService.checkForNewVersion();
            } else {
                this.new_version_available = false
            }
        },

        showDialog(params) 
        {
            this.title = params.title == null ? 'Alert' : params.title;
            this.text = params.text;
            this.after_alert = params.after_alert;
            this.technical_details = params.technical_details;
            this.text_markdown = params.text_markdown == true;

            this.dialog = true;
        },

        onOk() {
            this.dialog = false;

            if ( this.after_alert != null )
            {
                this.after_alert();
            }
        },

        onClickTechnicalDetails()
        {
            this.$rc.technicalDetails({
                'title': 'Technical Details',
                'technical_details': this.technical_details,
            });
        },

        refreshPage()
        {
            VersionService.refreshToNewVersion();
        },
    },
}
</script>

<style lang="scss" scoped>
</style>